export default __webpack_public_path__ + "static/media/google-education-partner.953605c0.jpeg";